import { useEffect, useState } from "react";
import axios from "axios";
import { Button, Card, Form } from "react-bootstrap";
import Header from "./Header";

function Gpscamera003() {
  const [currentStatus, setCurrentStatus] = useState(null);
  const [currentUrl, setCurrentUrl] = useState("");
  const [currentIsEmptySpaceAdOn, setCurrentIsEmptySpaceAdOn] = useState(null);
  const [currentIsEmptySpaceUrl, setCurrentIsEmptySpaceUrl] = useState(null);

  const [statusInput, setStatusInput] = useState(false);
  const [urlInput, setUrlInput] = useState("");

  const [isEmptySpaceAdOn, setIsEmptySpaceAdOn] = useState(false);
  const [isEmptySpaceUrl, setIsEmptySpaceUrl] = useState("");


    const API_URL = "https://appapi.banksstatements.com/003gpscamera";
//   const API_URL = "http://localhost:3002/003gpscamera";

  // 🔹 GET on load
  const fetchData = async () => {
    const res = await axios.get(API_URL);
    setCurrentStatus(res.data.isAdOnOff);
    setCurrentUrl(res.data.url);
    setStatusInput(Boolean(res.data.isAdOnOff));
    setCurrentIsEmptySpaceAdOn(res.data.isEmptySpaceAdOn);
    setCurrentIsEmptySpaceUrl(res.data.isEmptySpaceUrl);
    setIsEmptySpaceAdOn(Boolean(res.data.isEmptySpaceAdOn));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const updateData = async () => {
    const payload = {
      isAdOnOff: statusInput,
      isEmptySpaceAdOn: isEmptySpaceAdOn,
    };

    // 🔥 Only send url if user typed something
    if (urlInput.trim() !== "") {
      payload.url = urlInput;
    }

    if (isEmptySpaceUrl.trim() !== "") {
      payload.isEmptySpaceUrl = isEmptySpaceUrl;
    }

    await axios.post(API_URL, payload);

    fetchData();
    setUrlInput("");
    setIsEmptySpaceUrl("");
  };
  return (
    <>
      <Header />
      <div className="d-flex justify-content-center flex-column align-items-center mt-5">
        <div style={{ padding: 20 }}>
          <h2 className="text-center"> 003 Gps camera</h2>
          <div className="d-flex gap-4 mt-5">
            <Card className="card ">
              <p className="pt-3">
                Current Status:
                <b style={{ color: currentStatus ? "green" : "red" }}>
                  {currentStatus === null
                    ? " Loading..."
                    : currentStatus
                      ? " true"
                      : " false"}
                </b>
              </p>

              <p>Current URL: {currentUrl}</p>

              <Form.Group className="pt-3">
                <Form.Label> Status</Form.Label>
                <Form.Check
                  type="switch"
                  id="ad-switch"
                  // label={statusInput ? "true" : "false"}
                  label={
                    <span className="ms-2">
                      {statusInput ? "true" : "false"}
                    </span>
                  }
                  checked={statusInput}
                  onChange={(e) => setStatusInput(e.target.checked)}
                />
              </Form.Group>
              <br />

              <Form.Group className="" controlId="">
                <Form.Label>Url</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter new URL"
                  value={urlInput}
                  onChange={(e) => setUrlInput(e.target.value)}
                  style={{ width: "300px" }}
                />
              </Form.Group>

              <br />
              <br />
            </Card>
            <Card className="card">
              <p>
                isEmptySpaceAdOn :{" "}
                <b style={{ color: currentIsEmptySpaceAdOn ? "green" : "red" }}>
                  {currentIsEmptySpaceAdOn === null
                    ? " Loading..."
                    : currentIsEmptySpaceAdOn
                      ? " true"
                      : " false"}
                </b>
              </p>

              <p>isEmptySpaceUrl : {currentIsEmptySpaceUrl}</p>
              <Form.Group className="pt-3">
                <Form.Label> isEmptySpaceAdOn</Form.Label>
                <Form.Check
                  type="switch"
                  id="emptyspace-switch"
                  // label={statusInput ? "true" : "false"}
                  label={
                    <span className="ms-2">
                      {isEmptySpaceAdOn ? "true" : "false"}
                    </span>
                  }
                  checked={isEmptySpaceAdOn}
                  onChange={(e) => setIsEmptySpaceAdOn(e.target.checked)}
                />
              </Form.Group>
              <br />
              <Form.Group className="" controlId="">
                <Form.Label>Url</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter new URL"
                  value={isEmptySpaceUrl}
                  onChange={(e) => setIsEmptySpaceUrl(e.target.value)}
                  style={{ width: "300px" }}
                />
              </Form.Group>
            </Card>
          </div>

          {/* <button onClick={updateData}>Update</button> */}
          <div className="d-flex justify-content-center">
            <Button onClick={updateData} className="mt-4 " variant="primary">
              Update
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Gpscamera003;
